export const STAGE_BY_TIME = "Stage by time"
export const PRIORITY = "Priority";
export const STATION_PAIRS = "Stations";
export const PICK_BY_TIME = "Pick by Time";
export const ROUTE_ID = "Route ID";
export const STATION = "Station";
export const STATUS = "Status";
export const BAGS = "Bags";
export const OVS = "OVs";
export const CARTS = "Carts";
export const SPR = "SPR";
export const PROGRESS = "Progress";
export const ASSOCIATE = "Associate";
export const DURATION = "Duration";
export const TYPE = "Type";
export const AISLES = "Aisles";
export const ASSIGNED_WORK_GROUP = "Assigned Work Group";
export const NEXT_WORK_GROUPS = "Next Work Groups";
export const PICKLIST_CODE = "Picklist Code";
export const LAST_PICK = "Last Pick";

export const PICK_TABLE_COLUMNS_AR = [
    STATION_PAIRS,
    PICK_BY_TIME,
    ROUTE_ID,
    STATUS,
    CARTS,
    PROGRESS,
    ASSOCIATE,
    DURATION,
    TYPE
]

export const PICK_TABLE_COLUMNS_AMZL = [
    STAGE_BY_TIME,
    PRIORITY,
    AISLES,
    ASSIGNED_WORK_GROUP,
    NEXT_WORK_GROUPS,
    ROUTE_ID,
    STATION,
    STATUS,
    BAGS,
    OVS,
    SPR,
    PROGRESS,
    ASSOCIATE,
    DURATION,
    TYPE
]

export const PICK_TABLE_COLUMNS_AMZL_PARALLEL_PICK_ENABLED = [
    PICKLIST_CODE,
    ...PICK_TABLE_COLUMNS_AMZL,
]


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickTableColumns.js